"use client";

import { CheckCircleIcon } from "staysure-component-library";

import RichText from "@/components/atoms/rich-text/rich-text";

import { useTravellersRequiredInformation } from "../../provider/travellers-required-information.provider";

export default function DescriptionSection() {
  const { isFormComplete, selectedStateCmsData } =
    useTravellersRequiredInformation();

  return (
    <div
      data-testid="question-details-test-id"
      id="question-details-section-id"
      className="flex flex-col items-center h-full md:pt-xxl md:pb-spacing-xxl pt-spacing-l pb-spacing-m px-spacing-m md:px-spacing-xxxl"
    >
      <div className="flex-1 flex flex-col justify-center items-center w-full">
        <div className="w-full">
          {isFormComplete && (
            <div className="mb-spacing-m flex justify-center">
              <CheckCircleIcon fill="transparent" size="XL" />
            </div>
          )}
          <h3 className="md:!text-3xl font-header-font text-center leading-[21px] md:leading-[34.1px] text-[20px] md:mb-spacing-m mb-spacing-xs text-dark-text-title">
            {selectedStateCmsData.heading}
          </h3>

          <div className="md:text-xs leading-[24px] md:leading-[27px] text-center text-2xs text-surface-neutral-option-2">
            <RichText
              className="lg:text-xs leading-[24px] lg:leading-[27px] text-center text-2xs text-surface-neutral-option-2"
              richText={selectedStateCmsData.description ?? ""}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
